<template>
  <div class="contact">
    <TopSection from="Home" page="Contact" :bottom="true" />
    <Map />
    <div class="center-wrapper contact-wrapper">
    <div class="contact-details">
      <ContactDetails />
    </div>
    </div>
  </div>
</template>

<script>
import TopSection from '@/components/molecules/TopSection'
import Map from '@/components/organisms/Map'
import ContactDetails from '@/components/molecules/ContactDetails'
export default {
  components: {
    TopSection,
    Map,
    ContactDetails
  },
  metaInfo() {
    return {
      title: 'Contact Us'
    }
  }
}
</script>

<style lang="sass" scoped>
.contact-wrapper
  display: flex
  .contact-details
    display: flex
    flex-direction: column
    width: 40%
    margin: 2.5em 0 9.4em 0 
    @media screen and (max-width: $lg-breakpoint)
      width: 100%
</style>
